import { singleton } from "tsyringe";
import { EventBus } from "../event-bus";
import { AppState } from "../app-state";
import { ScreensOrchestrator } from "./screens";
import { BackgroundComponent } from "../components/background";
import debounce from "lodash/debounce";

@singleton()
export class EventsOrchestrator {
  constructor(
    private eventBus: EventBus,
    private appState: AppState,
    private screens: ScreensOrchestrator,
    private background: BackgroundComponent
  ) {}
  init() {
    this.setupEvents();
  }
  private setupEvents() {
    window.addEventListener(
      "resize",
      debounce(() => {
        this.eventBus.emit("resize");
      }, 100)
    );
    this.eventBus.on("painting/click", async (data) => {
      if (this.appState.activePainting === data.key) {
        await this.screens.fromHomeToSamePainting();
      } else {
        this.appState.activePainting = data.key;
        await this.screens.fromHomeToPainting();
      }
    });
    this.eventBus.on("navBtn/day", async () => {
      await this.background.toggleAmbientLight();
    });
    this.eventBus.on("navBtn/home", async () => {
      await this.screens.fromPaintingToHome();
    });
    this.eventBus.on("navBtn/next", async () => {
      this.appState.goNextPainting();
      await this.screens.fromPaintingToPainting();
    });
    this.eventBus.on("navBtn/prev", async () => {
      this.appState.goPrevPainting();
      await this.screens.fromPaintingToPainting();
    });
  }
}
